(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[61007],{

/***/ 17812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40922);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4024);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93871);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, color !== 'default' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.label
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),

/***/ 80366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 23188:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password/forgot",
      function () {
        return __webpack_require__(28256);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5566);
/* harmony import */ var components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4534);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32692);





var MaterialModal = function(param) {
    var children = param.children, open = param.open, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        "aria-labelledby": "spring-modal-title",
        "aria-describedby": "spring-modal-description",
        className: "popup-wrap",
        open: open,
        onClose: closeModal,
        closeAfterTransition: true,
        disableScrollLock: true,
        BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        outline: 0,
        BackdropProps: {
            timeout: 500
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            in: open,
            className: "center2",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MaterialModal);


/***/ }),

/***/ 4534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39920);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);







/* Material-UI 모달 Fade */ var ModalFade = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Fade(props, ref) {
    var open = props.in, children = props.children, onEnter = props.onEnter, onExited = props.onExited, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "in",
        "children",
        "onEnter",
        "onExited"
    ]);
    var style = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)({
        config: {
            duration: 10
        },
        from: {
            opacity: 0
        },
        to: {
            opacity: open ? 1 : 0
        },
        onStart: function() {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: function() {
            if (!open && onExited) {
                onExited();
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        style: style
    }, other), {
        children: children
    }));
});
ModalFade.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().element),
    in: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool.isRequired),
    onEnter: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    onExited: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalFade);


/***/ }),

/***/ 28256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ forgot; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 14 modules
var Form = __webpack_require__(99499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/modal/MaterialModal.js
var MaterialModal = __webpack_require__(81268);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
;// CONCATENATED MODULE: ./components/modal/MainPageModal.js






/* 보관함 모달 */ var MainPageModal = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal;
    return(// <Modal visible={modalVisible} width="450" height="250" effect="fadeInUp" onClickAway={() => closeModal()}>
    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialModal/* default */.Z, {
        open: modalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "popup-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        "aria-label": "close",
                        className: "w-15 h-15",
                        onClick: closeModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-2xl text-primary font-bold font-gmarket-medium",
                            id: "modal-title",
                            children: "작성하신 이메일로 비밀번호 변경"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-2xl text-primary font-bold font-gmarket-medium",
                            id: "modal-title",
                            children: "메일이 전송되었습니다"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-0 text-888 font-gmarket-medium",
                            children: "비밀번호 변경 후 로그인 해 주세요."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "popup-footer center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "btn btn-modal-o",
                            children: "마켓으로 이동하기"
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var modal_MainPageModal = (MainPageModal);

// EXTERNAL MODULE: ./components/Alert.js
var Alert = __webpack_require__(34950);
// EXTERNAL MODULE: ./node_modules/firebase/app/dist/index.esm.js
var index_esm = __webpack_require__(15503);
// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(72211);
;// CONCATENATED MODULE: ./pages/password/forgot/index.js









var firebaseConfig = {
    apiKey: "AIzaSyAOqeao7F5v3sPtmj65yw3hwD78zbz2-AI",
    authDomain: "aiso-api.firebaseapp.com",
    projectId: "aiso-api",
    storageBucket: "aiso-api.appspot.com",
    messagingSenderId: "286868520204",
    appId: "1:286868520204:web:f4f5e812966aef5e129d29",
    measurementId: "G-XD3LEKPFXX"
};
if (index_esm/* default.apps.length */.Z.apps.length === 0) {
    index_esm/* default.initializeApp */.Z.initializeApp(firebaseConfig);
}
var auth = index_esm/* default.auth */.Z.auth();
var ForgotPassword = function() {
    // email, password 값 저장
    var ref = (0,react.useState)(), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(false), modalVisible = ref1[0], setModalVisible = ref1[1];
    var sendButtonClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var value, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!email) {
                            (0,Alert/* BasicAlert */.N)("이메일을 입력해주세요.");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            auth.fetchSignInMethodsForEmail(email)
                        ];
                    case 2:
                        value = _state.sent();
                        if (!(value.length === 0)) return [
                            3,
                            3
                        ];
                        (0,Alert/* BasicAlert */.N)("등록된 메일이 없습니다.");
                        return [
                            2
                        ];
                    case 3:
                        return [
                            4,
                            auth.sendPasswordResetEmail(email).then(function() {
                                return console.log("메일이 정상적으로 전송되었습니다.");
                            }).catch(function(error) {
                                ;
                            })
                        ];
                    case 4:
                        _state.sent();
                        setModalVisible(true);
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        if (error.code === "auth/invalid-email") {
                            (0,Alert/* BasicAlert */.N)("이메일 주소 형식이 잘못되었습니다.");
                            return [
                                2
                            ];
                        } else {
                            (0,Alert/* BasicAlert */.N)(error.message);
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function sendButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center auth pt-5 pb-20 login-bg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row w-100 mx-0 h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 col-md-8 col-xl-4 mx-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-left py-5 px-4 px-sm-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-center mb-5 sign-font",
                                    children: "Forgot Password"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "text-blue-500",
                                    children: "Forgot Your Password"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "text-888",
                                    children: "Please enter your email"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                                    className: "pt-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                                            className: "d-flex search-field bg-white shadow-md",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                type: "email",
                                                placeholder: "Email",
                                                size: "lg",
                                                className: "h-auto",
                                                value: email,
                                                onChange: function(e) {
                                                    return setEmail(e.target.value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-4 shadow-md",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                className: "btn btn-block btn-primary auth-form-btn",
                                                onClick: function() {
                                                    return sendButtonClick();
                                                },
                                                children: "SEND"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-center mt-4 font-weight-light"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/header/img-logo-full@3x.png",
                                alt: "logo",
                                className: "w-2/12"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_MainPageModal, {
                modalVisible: modalVisible,
                closeModal: function() {
                    return setModalVisible(false);
                }
            })
        ]
    });
};
/* harmony default export */ var forgot = (ForgotPassword);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [76328,99499,49774,92888,40179], function() { return __webpack_exec__(23188); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);